import useTableColumnBizProp from '../components/useTableColumnBizProp.jsx'
import Model from './ModelBdlogic.mjs'

export const useTableColumnRuleTitle = () => useTableColumnBizProp(
    {Model, prop: 'ruleTitle'}
)
